import { useState } from "react";
import { useGetAuth } from "../../../hooks/useGetAuthHook";
import { User } from "../../../types/types";
import { CreatePostModal } from "../../modals/ CreatePostModal";

const Create = () => {
  const { data: user, isLoading } = useGetAuth<User>("user");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="rounded-lg bg-white p-4 shadow-sm">
        <div className="mb-3 flex gap-3">
          {/* Real avatar when loaded — skeleton when loading */}
          {isLoading ? (
            <div className="h-12 w-12 shrink-0 rounded-full bg-orange-200 animate-pulse" />
          ) : (
            <img
              src={user?.photo_url || "/placeholder.svg"}
              alt={user?.name || "User"}
              className="h-12 w-12 shrink-0 rounded-full border-4 border-white object-cover shadow-md"
            />
          )}

          <div
            onClick={() => setIsModalOpen(true)}
            className="h-12 w-full rounded-full border cursor-pointer border-orange-200 bg-white flex items-center px-4 text-gray-500 hover:bg-gray-50 transition-colors"
          >
            What's on your mind, {user?.name?.split(" ")[0] || "Friend"}?
          </div>
        </div>
      </div>

      <CreatePostModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Create;
